import script from "./section-list-item-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./section-list-item-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__